import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PnToast } from '@privanot/shared-ui/primeng-acl/toast';
import { setStoredLanguage } from '@admin/shared/util/language-storage';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, TranslateModule, PnToast],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    private translateService = inject(TranslateService);

    constructor() {
        this.translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe((e) => setStoredLanguage(e.lang));
    }
}
